import { CREATE_INDICATORS, GET_INDICATOR_BY_ID, UPDATE_INDICATORS, UPDATE_INDICATORS_ORDER_INDEX } from "./graphql"
import { graphqlApolloClient } from "../graphql-apollo-client"
import { DELETE_INDICATORS } from "./graphql/delete-indicators"

export const indicatorService = indicatorRepository => {
  /**
   * @param {string} id
   * @return Promise<Indicator>
   */
  const getIndicatorById = async ({ id }) => {
    const result = await graphqlApolloClient.query({
      query: GET_INDICATOR_BY_ID,
      fetchPolicy: "network-only",
      variables: { id }
    })

    return result?.data?.objectivesAndActivitiesTabIndicator || null
  }

  /**
   * @param {Array<UpdatedIndicator>} updatedIndicators
   * @returns {Promise<boolean>}
   */
  const updateIndicatorsOrderIndex = async ({ updatedIndicators }) => {
    const result = await graphqlApolloClient.mutate({
      mutation: UPDATE_INDICATORS_ORDER_INDEX,
      variables: { data: updatedIndicators }
    })

    return result?.data?.UpdateIndicatorsOrderIndex
  }

  const updateIndicators = async ({ indicators }) => {
    const { data } = await graphqlApolloClient.mutate({
      mutation: UPDATE_INDICATORS,
      variables: { indicators }
    })

    return data?.updateActivities
  }

  const createIndicators = async ({ indicators }) => {
    const { data } = await graphqlApolloClient.mutate({
      mutation: CREATE_INDICATORS,
      variables: { indicators }
    })

    return data?.createActivities
  }

  const deleteIndicators = async ({ indicatorIds }) => {
    const { data } = await graphqlApolloClient.mutate({
      mutation: DELETE_INDICATORS,
      variables: { indicatorIds }
    })

    return data?.deleteIndicators
  }

  return {
    getIndicatorById,
    createIndicators,
    updateIndicators,
    deleteIndicators,
    updateIndicatorsOrderIndex
  }
}

/**
 * @typedef Indicator
 * @property {string} id
 * @property {string} goal
 * @property {array.<string>} products
 * @property {array.<MeansOfVerification>} meansOfVerificationPerMonth
 */

/**
 * @typedef MeansOfVerification
 * @property {string} id
 * @property {number} month
 * @property {number} year
 * @property {number} monthProgress
 * @property {boolean} isRevisionBlocked
 * @property {array.<Document>} verificationDocumentsPerMonth
 */

/**
 * @typedef Document
 * @property {string} id
 * @property {string} url
 * @property {string} name
 * @property {string} type
 */

/**
 * @typedef UpdatedIndicator
 * @property {string} id
 * @property {number} orderIndex
 */
